import { render, staticRenderFns } from "./SubmitDemoTabInfo.vue?vue&type=template&id=4f48f278&scoped=true"
import script from "./SubmitDemoTabInfo.vue?vue&type=script&lang=js"
export * from "./SubmitDemoTabInfo.vue?vue&type=script&lang=js"
import style0 from "./SubmitDemoTabInfo.vue?vue&type=style&index=0&id=4f48f278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f48f278",
  null
  
)

export default component.exports